module.exports = __webpack_public_path__ + "assets/img/btn-back-bb3a13e0.png";